<script setup>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const currentTime = ref(0);
const startTime = ref(0);

const duration = ref(2500);

onMounted(() => {
    currentTime.value = Date.now();
    startTime.value = Date.now();

    setInterval(() => {
        currentTime.value = Date.now();
        if (currentTime.value - startTime.value > duration.value) {
            store.commit('loadingScreen', false)
        }
    }, 100)
})


</script>

<template>
    <transition name="fade">
        <div class="loading-screen" v-if="store.getters.loadingScreen">
            <div class="loading-area">
                <img class="image" src="../../public/assets/imgs/initial-loader-nascar.png">
                <loading-spinner class = "timer-bar"></loading-spinner>
                <div class="developed-by">
                    DEVELOPED BY
                </div>
                <img class="trigger-logo" src="../../public/assets/imgs/initial-loader-trigger.png">
            </div>
            
        </div>
    </transition>

</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';

.loading-screen {
    position: fixed;
    background-color: black;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    z-index: 5;

    .developed-by {
        font-family: GoogleSansFlex;
        position: relative;
        font-weight: 500;
        font-size: vw(10);
        color: #F4F4F4;
        margin-top: vw(30);
    }

    .trigger-logo {
        position: relative;
        width: vw(130);
        height: vw(14);
        margin-top: vw(3);
    }

    .loading-area {
        position: relative;
        width: vw(468);
        height: vw(484);
        background: linear-gradient(132.96deg, rgba(199, 199, 199, 0.5) -27.09%, rgba(79, 79, 79, 0.5) 27.74%, rgba(129, 129, 129, 0.5) 99.43%);
        border-radius: vw(8);

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .image {
            position: relative;
            width: vw(362);
            height: vw(60);
            margin-bottom: vw(30);
            margin-top: vw(-64);
        }

        .timer-bar {
            position: relative;
            
        }
    }

}
</style>
